(function () {
  if (customElements.get('ed-customer-wishlist')) return;

  function attr(el, name, fallback) {
    var value = el.getAttribute(name);
    if (value == null || value === '') return fallback || '';
    return value;
  }

  function parseJson(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'object') return value;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  function isProductLike(value) {
    if (!value || typeof value !== 'object') return false;
    if (value.product && typeof value.product === 'object') return true;
    if (value.product_id || value.productId || value.proID || value.proId) return true;
    if (value.variant_id || value.variantId || value.varID || value.varId) return true;
    if (value.handle || value.product_handle || value.productHandle) return true;
    if (value.sku && (value.title || value.image || value.featured_image)) return true;
    if (value.title && (value.image || value.featured_image || value.url || value.product_url)) return true;
    return false;
  }

  function asArray(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.reduce(function (list, entry) {
        return list.concat(asArray(entry));
      }, []);
    }
    if (typeof value === 'string' || typeof value === 'number') return [value];
    if (typeof value !== 'object') return [];
    var keys = [
      'wishlist_products',
      'wishlistProducts',
      'wishlistItems',
      'wishlist_items',
      'wishlist',
      'wishlists',
      'products',
      'items',
      'data',
      'list',
      'lists',
      'records',
      'result',
    ];
    for (var i = 0; i < keys.length; i++) {
      if (value[keys[i]] && value[keys[i]] !== value) {
        var nested = asArray(value[keys[i]]);
        if (nested.length) return nested;
      }
    }
    if (isProductLike(value)) return [value];
    return [];
  }

  function isListRecord(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    if (value.list_id || value.listId || value.wishlist_id || value.wishlistId) return true;
    if (value.is_default != null || value.default_list || value.isDefault != null) return true;
    if (value.name && (value.products || value.items || value.wishlist_products)) return true;
    return false;
  }

  function asWishlistArray(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.reduce(function (list, entry) {
        return list.concat(asWishlistArray(entry));
      }, []);
    }
    if (typeof value === 'string' || typeof value === 'number') return [value];
    if (typeof value !== 'object') return [];
    var keys = [
      'wishlist_products',
      'wishlistProducts',
      'wishlistItems',
      'wishlist_items',
      'wishlist',
      'wishlists',
      'lists',
      'list',
    ];
    for (var i = 0; i < keys.length; i++) {
      if (value[keys[i]] && value[keys[i]] !== value) {
        var nested = asWishlistArray(value[keys[i]]);
        if (nested.length) return nested;
      }
    }
    if (isListRecord(value)) {
      var nestedKeys = ['products', 'items', 'data'];
      for (var j = 0; j < nestedKeys.length; j++) {
        if (value[nestedKeys[j]] && value[nestedKeys[j]] !== value) {
          var inner = asWishlistArray(value[nestedKeys[j]]);
          if (inner.length) return inner;
        }
      }
    }
    if (isProductLike(value)) return [value];
    return [];
  }

  function savedFlag(entry) {
    if (!entry || typeof entry !== 'object') return null;
    var keys = ['added', 'is_added', 'in_wishlist', 'is_wishlisted', 'wishlisted', 'isWishlist', 'inWishlist'];
    for (var i = 0; i < keys.length; i++) {
      if (!(keys[i] in entry)) continue;
      var value = entry[keys[i]];
      if (value === true || value === 'true' || value === 1 || value === '1') return true;
      if (value === false || value === 'false' || value === 0 || value === '0') return false;
    }
    return null;
  }

  function onlySaved(entries) {
    var list = (entries || []).filter(function (entry) {
      return entry != null && entry !== '';
    });
    var flagged = list.some(function (entry) {
      return savedFlag(entry) !== null;
    });
    if (!flagged) return list;
    return list.filter(function (entry) {
      return savedFlag(entry) !== false;
    });
  }

  function numericId(value) {
    if (value == null || value === '') return '';
    var text = String(value);
    var gid = text.match(/(\d+)\s*$/);
    if (gid) return gid[1];
    return text.replace(/\D/g, '') || '';
  }

  function handleFromUrl(url) {
    if (!url || String(url).indexOf('/products/') === -1) return '';
    return String(url).split('/products/')[1].split(/[?#]/)[0] || '';
  }

  function cleanHandle(value) {
    if (!value) return '';
    var handle = String(value);
    if (handle.indexOf('/products/') !== -1) handle = handleFromUrl(handle);
    handle = handle.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    if (!handle || /^\d+$/.test(handle)) return '';
    return handle;
  }

  function normalizeItem(raw) {
    if (!raw) return null;
    if (typeof raw === 'string' || typeof raw === 'number') {
      var id = numericId(raw);
      if (!id) return null;
      return { productId: id, variantId: '', handle: '', title: '', image: '', price: null, available: true };
    }
    var product = raw.product || raw;
    var handle = cleanHandle(
      raw.handle ||
        raw.product_handle ||
        raw.productHandle ||
        raw.urlName ||
        product.handle ||
        product.urlName
    );
    if (!handle) {
      handle = cleanHandle(
        handleFromUrl(raw.url || raw.product_url || raw.productUrl || raw.link || product.url || product.productUrl || '')
      );
    }
    var variant = raw.variant || raw.selected_or_first_available_variant || product.selected_or_first_available_variant || {};
    var productId =
      numericId(raw.product_id || raw.productId || raw.proID || product.id || raw.id) || '';
    var variantId =
      numericId(
        raw.variant_id ||
          raw.variantId ||
          raw.varID ||
          variant.id ||
          (product.variants && product.variants[0] && product.variants[0].id)
      ) || '';
    var title = raw.title || raw.product_title || raw.productTitle || product.title || '';
    var image =
      imageSrc(raw.image) ||
      imageSrc(raw.featured_image) ||
      imageSrc(product.featured_image) ||
      imageSrc(product.featuredImage) ||
      (Array.isArray(product.images) && product.images[0] ? imageSrc(product.images[0]) : '') ||
      imageSrc(product.image) ||
      '';
    var price = raw.price != null ? raw.price : product.price != null ? product.price : variant.price;
    var available =
      raw.available != null
        ? !!raw.available
        : product.available != null
          ? !!product.available
          : true;
    var sku = raw.sku || raw.SKU || variant.sku || product.sku || '';
    if (!productId && !handle && !variantId) return null;
    return {
      productId: productId,
      variantId: variantId,
      handle: handle,
      title: title,
      image: image,
      price: price,
      available: available,
      sku: sku,
    };
  }

  function whenDragonGateReady() {
    if (window.__edDragonGateUsf && typeof window.__edDragonGateUsf.isAllowed === 'function') {
      return Promise.resolve(window.__edDragonGateUsf);
    }
    return new Promise(function (resolve) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (window.__edDragonGateUsf && typeof window.__edDragonGateUsf.isAllowed === 'function') {
          clearInterval(timer);
          resolve(window.__edDragonGateUsf);
          return;
        }
        if (tries > 24) {
          clearInterval(timer);
          resolve(null);
        }
      }, 50);
    });
  }

  function filterAllowed(items, ignorePageCollection) {
    var list = (items || []).filter(Boolean);
    var gate = window.__edDragonGateUsf;
    if (!gate || typeof gate.isAllowed !== 'function') return list;
    return list.filter(function (item) {
      return gate.isAllowed(item.handle, item, { ignorePageCollection: !!ignorePageCollection });
    });
  }

  function uniqueItems(items) {
    var seen = {};
    var out = [];
    items.forEach(function (item) {
      var key = item.variantId || item.productId || item.handle || item.sku;
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(item);
    });
    return out;
  }

  function formatMoney(cents, format) {
    if (cents == null || cents === '') return '';
    var amount = Number(cents);
    if (!isFinite(amount)) return '';
    if (amount > 0 && amount < 1000 && String(cents).indexOf('.') !== -1) {
      amount = Math.round(amount * 100);
    }
    var formatString = format || '{{amount}}';
    var placeholder = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return String(amount);
    function withDelimiters(number, precision, thousands, decimal) {
      var value = (Number(number) / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var formatted;
    switch (placeholder[1]) {
      case 'amount_no_decimals':
        formatted = withDelimiters(amount, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(amount, 0, '.', ',');
        break;
      default:
        formatted = withDelimiters(amount, 2, ',', '.');
    }
    return formatString.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function imageSrc(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || value.srcUrl || value.src_url || '';
  }

  function imageUrl(src, fallback) {
    if (!src) return fallback || '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function productUrl(item) {
    var handle = cleanHandle(item && item.handle);
    if (!handle) return '';
    return '/products/' + encodeURIComponent(handle);
  }

  function bindProductNav(el, url) {
    if (!el) return;
    if (!url) {
      el.removeAttribute('href');
      return;
    }
    el.setAttribute('href', url);
    el.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(url);
    });
  }

  function fetchJson(url, options) {
    return fetch(url, options || { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(
      function (response) {
        var type = (response.headers.get('content-type') || '').toLowerCase();
        if (!response.ok) return null;
        if (type.indexOf('json') === -1) {
          return response.text().then(function (text) {
            var parsed = parseJson(text);
            return parsed || { __html: text };
          });
        }
        return response.json().catch(function () {
          return null;
        });
      }
    );
  }

  function readLocalStorage() {
    var items = [];
    try {
      for (var i = 0; i < localStorage.length; i += 1) {
        var key = localStorage.key(i) || '';
        if (!/wishlist|hulk|favorit|saved[_-]?product/i.test(key)) continue;
        if (/config|settings|unique|button|style|count/i.test(key)) continue;
        var raw = localStorage.getItem(key);
        var parsed = parseJson(raw);
        if (parsed == null && raw && /^\s*[\d,]+\s*$/.test(raw)) {
          parsed = raw.split(',').map(function (part) {
            return part.trim();
          }).filter(Boolean);
        }
        onlySaved(asWishlistArray(parsed)).forEach(function (entry) {
          var item = normalizeItem(entry);
          if (item) items.push(item);
        });
      }
    } catch (e) {}
    return items;
  }

  function uniqueId() {
    try {
      var keys = ['hulk_wishlist_unique_id', 'hulkUniqueId', 'hulkapps_unique_id', 'hulk_unique_id'];
      for (var i = 0; i < keys.length; i += 1) {
        var value = localStorage.getItem(keys[i]);
        if (value) return value;
      }
    } catch (e) {}
    return '';
  }

  function itemsFromWishlistCards(root) {
    var items = [];
    if (!root || !root.querySelectorAll) return items;
    var cards = root.querySelectorAll(
      '[data-ed-wishlist-grid] .ed-customer-wishlist__card[data-ed-wishlist-saved="1"], [data-ed-wishlist-grid] .ed-usf-list-row[data-ed-wishlist-saved="1"]'
    );
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var link = card.querySelector('a[href*="/products/"]');
      var title = card.querySelector('.ed-usf-list-title');
      var sku = card.querySelector('.ed-usf-list-sku');
      var img = card.querySelector('img');
      var item = normalizeItem({
        product_id: card.getAttribute('data-product-id') || card.getAttribute('data-usf-pid'),
        variant_id: card.getAttribute('data-variant-id') || '',
        url: link ? link.getAttribute('href') : '',
        title: title ? String(title.textContent || '').trim() : '',
        sku: sku ? String(sku.textContent || '').replace(/^Varenr\.\s*/i, '').trim() : '',
        image: img ? img.getAttribute('src') || img.getAttribute('data-src') || '' : '',
      });
      if (item) items.push(item);
    }
    return uniqueItems(items);
  }

  function readWishlistCookies() {
    var items = [];
    try {
      var parts = String(document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i++) {
        var pair = parts[i].split('=');
        var key = String(pair[0] || '').trim();
        if (!/wishlist|hulk|favorit/i.test(key)) continue;
        if (/config|settings|button|style|count/i.test(key)) continue;
        var raw = '';
        try {
          raw = decodeURIComponent(pair.slice(1).join('=') || '').trim();
        } catch (err) {
          raw = (pair.slice(1).join('=') || '').trim();
        }
        var parsed = parseJson(raw);
        if (parsed == null && raw && /^\s*[\d,]+\s*$/.test(raw)) {
          parsed = raw.split(',').map(function (part) {
            return part.trim();
          }).filter(Boolean);
        }
        onlySaved(asWishlistArray(parsed)).forEach(function (entry) {
          var item = normalizeItem(entry);
          if (item) items.push(item);
        });
      }
    } catch (e) {}
    return items;
  }

  function headerWishlistCount() {
    var el = document.querySelector('[data-totalwishlistitems]');
    if (!el) return null;
    var n = parseInt(String(el.textContent || el.getAttribute('data-totalwishlistitems') || '').replace(/[^\d]/g, ''), 10);
    return isFinite(n) ? n : null;
  }

  function isCatalogDump(items) {
    if (!items || items.length < 2) return false;
    var usfItems = window.usf && usf.search && usf.search.result && usf.search.result.items;
    if (usfItems && usfItems.length) {
      var ids = {};
      usfItems.forEach(function (product) {
        if (product && product.id != null) ids[String(product.id)] = true;
      });
      var overlap = 0;
      items.forEach(function (item) {
        if (item.productId && ids[String(item.productId)]) overlap += 1;
      });
      if (items.length >= usfItems.length && overlap >= usfItems.length * 0.8 && usfItems.length >= 4) return true;
    }
    var count = headerWishlistCount();
    if (count != null && items.length > count + 1) return true;
    return false;
  }

  function fromHulkObject() {
    var items = [];
    var seen = {};
    function addPool(pool) {
      onlySaved(asWishlistArray(pool)).forEach(function (entry) {
        var item = normalizeItem(entry);
        if (!item) return;
        var key = item.variantId || item.productId || item.handle || item.sku;
        if (!key || seen[key]) return;
        seen[key] = true;
        items.push(item);
      });
    }
    [window.HulkappWishlist, window.hulkappsWishlist].forEach(function (hulk) {
      if (!hulk || typeof hulk !== 'object') return;
      addPool(hulk.wishlist_product_ids);
      addPool(hulk.wishlistProductIds);
      addPool(hulk.wishlistItems);
      addPool(hulk.wishlist_products);
      addPool(hulk.wishlistProducts);
      addPool(hulk.product_ids);
      addPool(hulk.productIds);
      addPool(hulk.savedProducts);
      if (hulk.wishlist && hulk.wishlist !== hulk.products) addPool(hulk.wishlist);
      if (hulk.wishlists && hulk.wishlists !== hulk.products) addPool(hulk.wishlists);
      if (hulk.wishlistData && hulk.wishlistData !== hulk.products) addPool(hulk.wishlistData);
      if (hulk.customerWishlist && hulk.customerWishlist !== hulk.products) addPool(hulk.customerWishlist);
      if (hulk.customer_wishlist) addPool(hulk.customer_wishlist);
      try {
        Object.keys(hulk).forEach(function (key) {
          if (!/wish|saved|favorit|product_ids|productIds/i.test(key)) return;
          if (/config|settings|button|style|count|url|base|shop|prefix/i.test(key)) return;
          addPool(hulk[key]);
        });
      } catch (e) {}
    });
    return items;
  }

  function attrOf(node, names) {
    if (!node || !node.getAttribute) return '';
    for (var i = 0; i < names.length; i++) {
      var value = node.getAttribute(names[i]);
      if (value) return value;
    }
    return '';
  }

  function itemsFromDoc(root) {
    var items = [];
    if (!root || !root.querySelectorAll) return items;
    var seen = {};
    function push(raw) {
      var item = normalizeItem(raw);
      if (!item) return;
      if (!item.handle && !item.title && !item.image && !item.sku) return;
      var key = item.handle || item.variantId || item.productId || item.sku;
      if (!key || seen[key]) return;
      seen[key] = true;
      items.push(item);
    }
    var nodes = root.querySelectorAll(
      '[data-added="true"][data-proid], [data-added="true"][data-product-id], .wishlist-btn[data-added="true"], [data-wishList][data-added="true"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.closest && node.closest('.ed-customer-wishlist, [data-ed-special-box], header, footer, nav, .ed-header-actions, #usf_container, .ed-selected-collection')) continue;
      var href = node.getAttribute('href') || '';
      var card = node.closest
        ? node.closest('[class*="wishlist"], [class*="product"], [data-product-id], [data-proid], li, article, tr') ||
          node
        : node;
      if (card && card.closest && card.closest('.ed-customer-wishlist')) continue;
      var img = (card.querySelector && card.querySelector('img')) || null;
      var titleEl =
        (card.querySelector &&
          card.querySelector('h2, h3, h4, .product-title, .product_title, [class*="title"], [class*="name"]')) ||
        null;
      var skuEl = (card.querySelector && card.querySelector('[class*="sku"], .sku, [data-sku]')) || null;
      var variantFromUrl = '';
      if (href.indexOf('variant=') !== -1) {
        variantFromUrl = href.split('variant=')[1].split('&')[0];
      }
      var productLink = card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
      push({
        product_id:
          attrOf(node, ['data-proid', 'data-product-id', 'data-productid']) ||
          attrOf(card, ['data-proid', 'data-product-id', 'data-productid']),
        variant_id:
          attrOf(node, ['data-varid', 'data-variant-id']) ||
          attrOf(card, ['data-varid', 'data-variant-id']) ||
          variantFromUrl,
        url: href.indexOf('/products/') !== -1 ? href : productLink ? productLink.getAttribute('href') : '',
        title: ((titleEl && titleEl.textContent) || '').trim(),
        image: img ? img.getAttribute('src') || img.getAttribute('data-src') || '' : '',
        sku: ((skuEl && skuEl.textContent) || attrOf(card, ['data-sku']) || '').trim(),
      });
    }
    return items;
  }

  function itemsFromHtml(html) {
    if (!html) return [];
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var main = doc.getElementById('MainContent') || doc.body || doc;
      var parsed = itemsFromDoc(main);
      if (parsed.length) return parsed;
    } catch (e) {}
    return [];
  }

  function waitForPageItems() {
    if (!document.body || !document.body.classList.contains('ed-wishlist-app')) {
      return Promise.resolve([]);
    }
    var main = document.getElementById('MainContent');
    var first = itemsFromDoc(main || document);
    if (first.length) return Promise.resolve(first);
    return new Promise(function (resolve) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        var found = itemsFromDoc(document.getElementById('MainContent') || document);
        if (found.length || tries > 6) {
          clearInterval(timer);
          resolve(found);
        }
      }, 120);
    });
  }

  function usfProductHandle(product) {
    if (!product) return '';
    return cleanHandle(
      product.handle ||
        product.urlName ||
        product.url_name ||
        handleFromUrl(product.url || product.productUrl || '')
    );
  }

  function findUsfProduct(item) {
    var items = window.usf && usf.search && usf.search.result && usf.search.result.items;
    if (!items || !items.length) return null;
    for (var i = 0; i < items.length; i++) {
      var product = items[i];
      if (item.productId && String(product.id) === String(item.productId)) return product;
      var handle = usfProductHandle(product);
      if (item.handle && handle && handle === item.handle) return product;
    }
    return null;
  }

  function productMetaMap(product) {
    var map = {};
    var metafields = product && product.metafields;
    if (!metafields) return map;
    if (Array.isArray(metafields)) {
      metafields.forEach(function (m) {
        if (!m || !m.key) return;
        map[m.key] = m.value;
      });
      return map;
    }
    if (typeof metafields === 'object') {
      Object.keys(metafields).forEach(function (ns) {
        var group = metafields[ns];
        if (!group || typeof group !== 'object') return;
        Object.keys(group).forEach(function (key) {
          var val = group[key];
          if (val && typeof val === 'object' && 'value' in val) val = val.value;
          map[key] = val;
        });
      });
    }
    return map;
  }

  function dimensionsFromTitle(title) {
    if (!title) return '';
    var match = String(title).match(/(\d+(?:[.,]\d+)?(?:\s*x\s*\d+(?:[.,]\d+)?){1,3}(?:\s*mm|\s*m)?)/i);
    return match ? match[1].replace(/\s+/g, ' ').trim() : '';
  }

  function colourFromText(value) {
    if (!value) return '';
    var text = String(value);
    var colours = [
      'brun',
      'hvid',
      'sort',
      'grå',
      'graa',
      'gron',
      'grøn',
      'blå',
      'blaa',
      'rød',
      'rod',
      'gul',
      'orange',
      'lilla',
      'transparent',
      'klar',
      'brown',
      'white',
      'black',
      'grey',
      'gray',
      'green',
      'blue',
      'red',
      'yellow',
    ];
    var lower = text.toLowerCase();
    for (var i = 0; i < colours.length; i++) {
      if (new RegExp('(?:^|\\s)' + colours[i] + '(?:\\s|$)', 'i').test(lower)) {
        var found = text.match(new RegExp(colours[i], 'i'));
        return found ? found[0] : colours[i];
      }
    }
    return '';
  }

  function priceToCents(value) {
    if (value == null || value === '') return null;
    var raw = String(value).trim();
    var n = Number(raw.replace(',', '.'));
    if (!isFinite(n)) return null;
    if (raw.indexOf('.') !== -1 || raw.indexOf(',') !== -1) return Math.round(n * 100);
    return n;
  }

  function applyProductData(item, product) {
    if (!product) return item;
    var variants = product.variants || [];
    var variant =
      variants.find(function (entry) {
        return String(entry.id) === String(item.variantId) || (item.sku && String(entry.sku || '') === String(item.sku));
      }) ||
      variants[0] ||
      {};
    item.productId = item.productId || String(product.id || '');
    item.variantId = item.variantId || String(variant.id || product.selectedVariantId || '') || '';
    item.handle = cleanHandle(item.handle || usfProductHandle(product) || product.handle);
    item.title = item.title || product.title || '';
    item.sku = item.sku || (variant && variant.sku) || product.sku || '';
    if (product.available != null) item.available = !!product.available;
    if (!item.image) {
      item.image =
        imageSrc(product.featured_image) ||
        imageSrc(product.featuredImage) ||
        (product.images && product.images[0] ? imageSrc(product.images[0]) : '') ||
        imageSrc(product.image) ||
        '';
    }
    var nextPrice = priceToCents(variant.price != null ? variant.price : product.price);
    var nextCompare = priceToCents(
      variant.compare_at_price || variant.compareAtPrice || product.compare_at_price || product.compareAtPrice
    );
    if (nextCompare != null && (nextPrice == null || nextCompare < nextPrice)) nextPrice = nextCompare;
    if (nextPrice != null) item.price = nextPrice;
    var meta = productMetaMap(product);
    if (!item.dimensions) {
      var l = meta.laengde || meta.length_internal_mm;
      var w = meta.bredde || meta.width_internal_mm;
      var h = meta.hojde_mm || meta.height_internal_mm;
      if (l && w && h) item.dimensions = l + ' x ' + w + ' x ' + h + ' mm';
      else if (l && w) item.dimensions = l + ' x ' + w + ' mm';
      else if (meta.format) item.dimensions = /mm/i.test(String(meta.format)) ? String(meta.format) : meta.format + ' mm';
      else item.dimensions = dimensionsFromTitle(item.title || product.title);
    }
    if (!item.typeQuality) {
      item.typeQuality = meta.kvalitet || meta.box_quality || product.product_type || product.type || '';
    }
    if (!item.colour) {
      item.colour = meta.colour || meta.farve || meta.color || colourFromText(item.title || product.title);
    }
    return item;
  }

  function waitForUsfItems() {
    var items = window.usf && usf.search && usf.search.result && usf.search.result.items;
    if (items && items.length) return Promise.resolve(items);
    if (!window._usfHasContainer) return Promise.resolve([]);
    return new Promise(function (resolve) {
      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        resolve((window.usf && usf.search && usf.search.result && usf.search.result.items) || []);
      }
      var timer = setTimeout(finish, 2500);
      if (window.usf && usf.event && typeof usf.event.add === 'function') {
        usf.event.add('sr_dataReceived', function () {
          clearTimeout(timer);
          finish();
        });
        usf.event.add('sr_updated', function () {
          clearTimeout(timer);
          finish();
        });
      }
    });
  }

  function productsFromSuggest(data) {
    if (!data) return [];
    var resources = data.resources || data;
    var results = resources.results || resources;
    return asArray(results.products || results.items || results);
  }

  function fetchProductById(id) {
    if (!id) return Promise.resolve(null);
    var urls = [
      '/search/suggest.json?q=' + encodeURIComponent(id) + '&resources[type]=product&resources[limit]=6',
      '/search/suggest.json?q=' + encodeURIComponent('id:' + id) + '&resources[type]=product&resources[limit]=4',
    ];
    function tryUrl(index) {
      if (index >= urls.length) return Promise.resolve(null);
      return fetchJson(urls[index]).then(function (data) {
        var products = productsFromSuggest(data);
        var match = products.find(function (product) {
          return String(product.id) === String(id) || String(product.product_id) === String(id);
        });
        if (match) return match;
        return tryUrl(index + 1);
      });
    }
    return tryUrl(0);
  }

  function fetchProductByHandle(handle) {
    var clean = cleanHandle(handle);
    if (!clean) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(clean) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (data && window._edBssPriceFrom && typeof window._edBssPriceFrom.rememberProduct === 'function') {
          window._edBssPriceFrom.rememberProduct(data);
        }
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchProductBySku(sku) {
    var q = sku ? String(sku).trim() : '';
    if (!q) return Promise.resolve(null);
    return fetchProductByHandle(q.toLowerCase()).then(function (direct) {
      if (direct) return direct;
      return fetchJson(
        '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8'
      ).then(function (data) {
        var products = productsFromSuggest(data);
        var want = q.toLowerCase();
        var match = products.find(function (product) {
          if (String(product.sku || '').toLowerCase() === want) return true;
          if (cleanHandle(product.handle) === want) return true;
          var variants = product.variants || [];
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].sku || '').toLowerCase() === want) return true;
          }
          var url = String(product.url || product.handle || '').toLowerCase();
          if (url && url.indexOf(want) !== -1) return true;
          return false;
        });
        if (!match && products.length === 1) match = products[0];
        if (!match || !cleanHandle(match.handle)) return match || null;
        return fetchProductByHandle(match.handle).then(function (full) {
          return full || match;
        });
      });
    });
  }

  function fetchCollectionProducts(handle) {
    var clean = String(handle || '').replace(/^\/+|\/+$/g, '');
    if (!clean) return Promise.resolve([]);
    if (!fetchCollectionProducts._cache) fetchCollectionProducts._cache = {};
    if (fetchCollectionProducts._cache[clean]) return fetchCollectionProducts._cache[clean];
    fetchCollectionProducts._cache[clean] = fetch(
      '/collections/' + encodeURIComponent(clean) + '/products.json?limit=250',
      { credentials: 'same-origin', headers: { Accept: 'application/json' } }
    )
      .then(function (response) {
        return response.ok ? response.json() : { products: [] };
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
    return fetchCollectionProducts._cache[clean];
  }

  function findCollectionProduct(item, products) {
    if (!products || !products.length) return null;
    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      if (item.productId && String(product.id) === String(item.productId)) return product;
      var handle = cleanHandle(product.handle);
      if (item.handle && handle && handle === item.handle) return product;
      if (item.sku && product.variants) {
        for (var v = 0; v < product.variants.length; v++) {
          if (String(product.variants[v].sku || '') === String(item.sku)) return product;
        }
      }
    }
    return null;
  }

  function hydrateProduct(item, collectionProducts) {
    item.handle = cleanHandle(item.handle);
    if (!item.dimensions) item.dimensions = dimensionsFromTitle(item.title);
    if (!item.colour) item.colour = colourFromText(item.title);
    applyProductData(item, findUsfProduct(item));
    applyProductData(item, findCollectionProduct(item, collectionProducts));
    function missingDetails() {
      return !item.variantId || !item.dimensions || !item.typeQuality || item.price == null || !item.image;
    }
    function withHandle() {
      if (!cleanHandle(item.handle)) return Promise.resolve(item);
      if (!missingDetails() && item.title) return Promise.resolve(item);
      return fetchProductByHandle(item.handle).then(function (product) {
        if (product) return applyProductData(item, product);
        var skuGuess = item.sku || item.handle;
        return fetchProductBySku(skuGuess).then(function (bySku) {
          return applyProductData(item, bySku);
        });
      });
    }
    if (cleanHandle(item.handle)) return withHandle();
    var sku = item.sku ? String(item.sku).trim() : '';
    if (sku) {
      return fetchProductBySku(sku).then(function (product) {
        applyProductData(item, product);
        if (cleanHandle(item.handle) && !missingDetails()) return item;
        if (!item.productId) return withHandle();
        return fetchProductById(item.productId).then(function (byId) {
          applyProductData(item, byId);
          return withHandle();
        });
      });
    }
    if (!item.productId) return Promise.resolve(item);
    return fetchProductById(item.productId).then(function (product) {
      applyProductData(item, product);
      return withHandle();
    });
  }

  var bssApplyTimer = null;
  var bssApplyTries = 0;

  function copyUsfPrices() {
    var sources = document.querySelectorAll(
      '#usf_container .ed-usf-list-price[data-ed-product-id], #usf_container [data-ed-price-from][data-ed-product-id]'
    );
    var htmlById = {};
    for (var i = 0; i < sources.length; i++) {
      var src = sources[i];
      if (src.closest && src.closest('.ed-customer-wishlist')) continue;
      var pid = src.getAttribute('data-ed-product-id');
      var html = src.innerHTML;
      if (!pid || !html || !String(html).trim()) continue;
      if (!/\d/.test(String(html))) continue;
      if (src.querySelector && src.querySelector('.ed-login-price')) continue;
      htmlById[String(pid)] = html;
    }
    var targets = document.querySelectorAll('.ed-customer-wishlist [data-ed-price-from][data-ed-product-id]');
    for (var j = 0; j < targets.length; j++) {
      var cell = targets[j];
      if (cell.getAttribute('data-ed-price-from-applied')) continue;
      var current = String(cell.textContent || '').replace(/\s+/g, '');
      if (/\d/.test(current)) continue;
      var id = cell.getAttribute('data-ed-product-id');
      if (id && htmlById[String(id)]) cell.innerHTML = htmlById[String(id)];
    }
  }

  function applyBssPrices() {
    copyUsfPrices();
    try {
      if (window._edBssPriceFrom && typeof window._edBssPriceFrom.refresh === 'function') {
        window._edBssPriceFrom.refresh();
      }
    } catch (e) {}
    copyUsfPrices();
    bssApplyTries = 0;
    if (bssApplyTimer) clearInterval(bssApplyTimer);
    bssApplyTimer = setInterval(function () {
      bssApplyTries += 1;
      copyUsfPrices();
      if (bssApplyTries === 3 || bssApplyTries === 7) {
        try {
          if (window._edBssPriceFrom && typeof window._edBssPriceFrom.refresh === 'function') {
            window._edBssPriceFrom.refresh();
          }
        } catch (e) {}
        copyUsfPrices();
      }
      if (bssApplyTries > 8) {
        clearInterval(bssApplyTimer);
        bssApplyTimer = null;
      }
    }, 300);
  }

  class EdCustomerWishlist extends HTMLElement {
    connectedCallback() {
      this.statusEl = this.querySelector('[data-ed-wishlist-status]');
      this.gridEl = this.querySelector('[data-ed-wishlist-grid]');
      this.specialStatusEl = this.querySelector('[data-ed-special-status]');
      this.specialGridEl = this.querySelector('[data-ed-special-grid]');
      if (!this._edPriceBound) {
        this._edPriceBound = true;
        document.addEventListener('ed:bss-price-from-ready', function () {
          applyBssPrices();
        });
      }
      this.load();
    }

    setStatus(text, isError) {
      if (!this.statusEl) return;
      if (!text) {
        this.statusEl.hidden = true;
        this.statusEl.textContent = '';
        return;
      }
      this.statusEl.hidden = false;
      this.statusEl.textContent = text;
      this.statusEl.classList.toggle('ed-customer-wishlist__status--error', !!isError);
    }

    setSpecialStatus(text) {
      if (!this.specialStatusEl) return;
      if (!text) {
        this.specialStatusEl.hidden = true;
        this.specialStatusEl.textContent = '';
        return;
      }
      this.specialStatusEl.hidden = false;
      this.specialStatusEl.textContent = text;
    }

    specialItems() {
      var node = this.querySelector('[data-ed-special-products]');
      var parsed = node ? parseJson(node.textContent) : null;
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(function (entry) {
          var item = normalizeItem(entry);
          if (!item) return null;
          item.dimensions = entry.dimensions || '';
          item.typeQuality = entry.typeQuality || '';
          item.colour = entry.colour || '';
          item.stockClass = entry.stockClass || '';
          item.stockText = entry.stockText || '';
          item.moq = entry.moq || 1;
          item.saved = false;
          return item;
        })
        .filter(Boolean);
    }

    refreshHearts(root) {
      var scope = root || this;
      if (!window.HulkappWishlist || typeof HulkappWishlist._checkForProductStatus !== 'function') return;
      var buttons = Array.from(scope.querySelectorAll('.ed-wishlist [data-wishlist], .ed-wishlist [data-wishList]')).filter(
        function (btn) {
          return btn.getAttribute('data-proid') || btn.getAttribute('data-proID');
        }
      );
      if (!buttons.length) return;
      try {
        HulkappWishlist._checkForProductStatus(buttons, 'multiple');
      } catch (e) {}
    }

    load() {
      var self = this;
      var loggedIn = !!attr(this, 'data-customer-id');
      this.setStatus(loggedIn ? attr(this, 'data-loading') : attr(this, 'data-login-required') || attr(this, 'data-empty'));
      whenDragonGateReady()
        .then(function () {
          var specials = filterAllowed(self.specialItems(), false);
          return Promise.all(
            specials.map(function (item) {
              return hydrateProduct(item);
            })
          ).then(function (items) {
            self.renderSpecial(filterAllowed(items, false));
            if (!loggedIn) {
              if (self.gridEl) self.gridEl.hidden = true;
              self.setStatus(attr(self, 'data-login-required') || attr(self, 'data-empty'));
              return [];
            }
            return self.collectItems();
          });
        })
        .then(function (items) {
          if (!items || !items.length) return [];
          var collectionHandle = attr(self, 'data-collection-handle');
          return fetchCollectionProducts(collectionHandle).then(function (products) {
            return Promise.all(
              items.map(function (item) {
                return hydrateProduct(item, products);
              })
            );
          });
        })
        .then(function (items) {
          var ready = uniqueItems(
            filterAllowed(
              items.filter(function (item) {
                return item && (item.productId || item.handle) && (productUrl(item) || item.title);
              }),
              true
            )
          );
          ready.forEach(function (item) {
            item.saved = true;
          });
          if (loggedIn) self.render(ready);
          if (window.__edDragonGateUsf && typeof window.__edDragonGateUsf.scrub === 'function') {
            window.__edDragonGateUsf.scrub();
          }
        })
        .catch(function () {
          if (loggedIn) self.render([]);
        });
    }

    renderSpecial(items) {
      if (!this.specialGridEl) return;
      this.specialGridEl.innerHTML = '';
      if (!items.length) {
        this.specialGridEl.hidden = true;
        this.setSpecialStatus(attr(this, 'data-special-empty'));
        return;
      }
      this.setSpecialStatus('');
      this.specialGridEl.hidden = false;
      this.fillGrid(this.specialGridEl, items, false);
      this.refreshHearts(this.specialGridEl);
      applyBssPrices();
    }

    collectItems() {
      function useful(item) {
        return item && (item.handle || item.title || item.image || item.sku || item.productId);
      }

      function localSaved() {
        return uniqueItems(
          fromHulkObject()
            .filter(useful)
            .concat(readLocalStorage().filter(useful))
            .concat(readWishlistCookies().filter(useful))
        );
      }

      function pageNow() {
        var root = document.getElementById('MainContent') || document;
        return uniqueItems(itemsFromDoc(root).filter(useful).concat(itemsFromWishlistCards(root).filter(useful)));
      }

      return new Promise(function (resolve) {
        var tries = 0;
        function current() {
          return uniqueItems(pageNow().concat(localSaved()));
        }
        function finish(items) {
          resolve(items.length && !isCatalogDump(items) ? items : localSaved());
        }
        function tick() {
          tries += 1;
          var items = current();
          var count = headerWishlistCount();
          var haveEnough = items.length && !isCatalogDump(items) && (count == null || items.length >= count);
          if (haveEnough || tries > 16) {
            finish(items);
            return true;
          }
          return false;
        }
        if (tick()) return;
        var timer = setInterval(function () {
          if (tick()) clearInterval(timer);
        }, 120);
      });
    }

    fillGrid(grid, items, saved) {
      var self = this;
      var hidePrices = attr(this, 'data-hide-prices') === 'true';
      var moneyFormat = attr(this, 'data-money-format');
      var placeholder = attr(this, 'data-placeholder');
      grid.insertAdjacentHTML(
        'afterbegin',
        '<div class="ed-usf-list-head" aria-hidden="true">' +
          '<div class="ed-usf-list-cell">Produkt</div>' +
          '<div class="ed-usf-list-cell">Dimensioner (L x B x H)</div>' +
          '<div class="ed-usf-list-cell">Type / Kvalitet</div>' +
          '<div class="ed-usf-list-cell">Farve</div>' +
          '<div class="ed-usf-list-cell">Lagerstatus</div>' +
          '<div class="ed-usf-list-cell">Pris fra (ekskl. moms)</div>' +
          '<div class="ed-usf-list-cell">Læg i kurv</div>' +
          '</div>'
      );
      items.forEach(function (item) {
        if (saved) item.saved = true;
        grid.appendChild(self.card(item, hidePrices, moneyFormat, placeholder));
      });
    }

    render(items) {
      if (!this.gridEl) return;
      this.gridEl.innerHTML = '';
      if (!items.length) {
        this.gridEl.hidden = true;
        this.setStatus(attr(this, 'data-empty'));
        return;
      }
      this.setStatus('');
      this.gridEl.hidden = false;
      this.fillGrid(this.gridEl, items, true);
      this.refreshHearts(this.gridEl);
      applyBssPrices();
    }

    card(item, hidePrices, moneyFormat, placeholder) {
      var root = document.createElement('div');
      root.className = 'ed-usf-list-row ed-customer-wishlist__card';
      var isSaved = item.saved !== false;
      root.setAttribute('data-ed-wishlist-saved', isSaved ? '1' : '0');
      if (item.productId) root.setAttribute('data-usf-pid', item.productId);
      if (item.productId) root.setAttribute('data-product-id', item.productId);
      if (item.handle) root.setAttribute('data-product-handle', item.handle);
      var url = productUrl(item);
      var img = escapeHtml(imageUrl(item.image, placeholder));
      var priceHtml = hidePrices
        ? '<a class="ed-login-price" href="' +
          escapeHtml(attr(this, 'data-login-url')) +
          '">' +
          escapeHtml(attr(this, 'data-login-text')) +
          '</a>'
        : escapeHtml(formatMoney(item.price, moneyFormat));
      if (!hidePrices && window._edBssPriceFrom && typeof window._edBssPriceFrom.get === 'function') {
        var from = window._edBssPriceFrom.get(item.productId, item.variantId, 'grid', {
          price: item.price,
          compareAt: item.compareAt || item.compare_at
        });
        if (from && from.html) priceHtml = from.html;
      }
      var canAdd = item.available && item.variantId;
      var actionLabel = canAdd ? attr(this, 'data-add-to-cart') : attr(this, 'data-view-product');
      if (!item.available) actionLabel = attr(this, 'data-sold-out');
      actionLabel = escapeHtml(actionLabel);
      var variantId = escapeHtml(item.variantId || '');
      var productId = escapeHtml(item.productId || '');
      var stockClass = item.stockClass || (item.available ? 'is-in' : 'is-out');
      var stockText = escapeHtml(item.stockText || (item.available ? attr(this, 'data-in-stock') : attr(this, 'data-sold-out')));
      var sku = escapeHtml(item.sku || '');
      var dash = '—';
      var dimensions = escapeHtml(item.dimensions || dash);
      var typeQuality = escapeHtml(item.typeQuality || dash);
      var colour = escapeHtml(item.colour || dash);
      var qtyMin = parseInt(item.moq, 10);
      if (!qtyMin || qtyMin < 1) qtyMin = 1;
      var qtyStep = qtyMin;
      if (window._edBssQi && typeof window._edBssQi.combine === 'function') {
        var qtyRule = window._edBssQi.combine(item.productId, qtyMin);
        qtyMin = qtyRule.min;
        qtyStep = qtyRule.step || qtyMin;
      }
      root.innerHTML =
        '<div class="ed-usf-list-cell ed-usf-list-cell--product">' +
        '<a class="ed-usf-list-product" href="' +
        escapeHtml(url) +
        '">' +
        '<img class="ed-usf-list-img" src="' +
        img +
        '" alt="" width="48" height="48" loading="lazy">' +
        '<span class="ed-usf-list-title-wrap"><span class="ed-usf-list-title"></span>' +
        (sku ? '<span class="ed-usf-list-sku">' + sku + '</span>' : '') +
        '</span></a></div>' +
        '<div class="ed-usf-list-cell">' +
        dimensions +
        '</div>' +
        '<div class="ed-usf-list-cell">' +
        typeQuality +
        '</div>' +
        '<div class="ed-usf-list-cell">' +
        colour +
        '</div>' +
        '<div class="ed-usf-list-cell"><span class="ed-usf-list-stock ' +
        stockClass +
        '">' +
        stockText +
        '</span></div>' +
        '<div class="ed-usf-list-cell ed-usf-list-price"' +
        (productId ? ' data-ed-product-id="' + productId + '"' : '') +
        (variantId ? ' data-ed-variant-id="' + variantId + '" data-variant-id="' + variantId + '"' : '') +
        (item.price != null && item.price !== '' ? ' data-ed-base-price="' + escapeHtml(item.price) + '"' : '') +
        ' data-ed-price-from data-ed-price-from-mode="grid"><span class="usf-price">' +
        priceHtml +
        '</span></div>' +
        '<div class="ed-usf-list-cell ed-usf-list-cell--action">' +
        (canAdd
          ? '<div class="ed-usf-qty ed-usf-qty--list">' +
            '<button type="button" class="ed-usf-qty__btn" data-ed-wishlist-qty-down aria-label="-">−</button>' +
            '<input type="number" class="ed-usf-qty__input" data-ed-qi-pid="' +
            productId +
            '" data-ed-qi-pack="' +
            (parseInt(item.moq, 10) || 1) +
            '" value="' +
            qtyMin +
            '" min="' +
            qtyMin +
            '" step="' +
            qtyStep +
            '">' +
            '<button type="button" class="ed-usf-qty__btn" data-ed-wishlist-qty-up aria-label="+">+</button>' +
            '</div>' +
            '<button type="button" class="ed-usf-list-atc" data-ed-wishlist-atc data-variant-id="' +
            variantId +
            '">' +
            actionLabel +
            '</button>'
          : '<a href="' + escapeHtml(url) + '" class="ed-usf-list-atc">' + actionLabel + '</a>') +
        '<div class="ed-wishlist ed-wishlist--grid" data-ed-wishlist>' +
        '<span class="ed-wishlist__fallback" aria-hidden="true">' +
        '<svg class="ed-wishlist__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" focusable="false">' +
        '<path d="M12 20s-7-4.35-7-9.2A3.8 3.8 0 0 1 12 7.1a3.8 3.8 0 0 1 7 3.7C19 15.65 12 20 12 20Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"></path>' +
        '</svg></span>' +
        '<a href="javascript:void(0)" rel="nofollow" class="icon-wishlist-heart-empty wishlist-btn grid-wishlist-btn heart-wishlist-animation" data-wishList data-gridHulkList data-added="' +
        (isSaved ? 'true' : 'false') +
        '" data-proid="' +
        productId +
        '" data-proID="' +
        productId +
        '" data-varid="' +
        (variantId || productId) +
        '" data-varID="' +
        (variantId || productId) +
        '">' +
        '<div class="wishlist_btn_icon"><i class="heart-hulk-animation"><i class="icon-wishlist-heart-empty"></i></i></div>' +
        '<span class="ed-wishlist__sr">' +
        attr(this, 'data-view-all') +
        '</span>' +
        '<span class="count">0</span></a></div></div>';
      var btn = root.querySelector('.wishlist-btn');
      if (btn && productId) {
        btn.setAttribute('data-proid', productId);
        btn.setAttribute('data-proID', productId);
        btn.setAttribute('data-varid', variantId || productId);
        btn.setAttribute('data-varID', variantId || productId);
        btn.setAttribute('data-added', isSaved ? 'true' : 'false');
      }
      var titleEl = root.querySelector('.ed-usf-list-title');
      if (titleEl) titleEl.textContent = item.title || item.handle || '';
      var imgEl = root.querySelector('img');
      if (imgEl) imgEl.alt = item.title || '';
      bindProductNav(root.querySelector('.ed-usf-list-product'), url);
      if (!canAdd) bindProductNav(root.querySelector('a.ed-usf-list-atc'), url);
      var qtyInput = root.querySelector('.ed-usf-qty__input');
      var qtyDown = root.querySelector('[data-ed-wishlist-qty-down]');
      var qtyUp = root.querySelector('[data-ed-wishlist-qty-up]');
      function readQty() {
        var min = qtyInput ? parseInt(qtyInput.getAttribute('min'), 10) : 1;
        if (!min || min < 1) min = 1;
        var value = qtyInput ? parseInt(qtyInput.value, 10) : min;
        if (!value || value < min) value = min;
        if (qtyInput) qtyInput.value = value;
        return value;
      }
      if (qtyDown) {
        qtyDown.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (qtyInput) {
            var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
            var step = parseInt(qtyInput.getAttribute('step'), 10) || min;
            qtyInput.value = Math.max(min, readQty() - step);
          }
        });
      }
      if (qtyUp) {
        qtyUp.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (qtyInput) {
            var step = parseInt(qtyInput.getAttribute('step'), 10) || 1;
            qtyInput.value = readQty() + step;
          }
        });
      }
      var atc = root.querySelector('[data-ed-wishlist-atc]');
      if (atc) {
        atc.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          addToCart(item.variantId, atc, readQty());
        });
      }
      return root;
    }
  }

  function addToCart(variantId, button, quantity) {
    if (window._edCartGate && window._edCartGate.allowed === false) {
      window.location.href = window._edCartGate.url || '/pages/create-an-account';
      return;
    }
    var id = parseInt(String(variantId).replace(/^.*\//, ''), 10);
    if (!id) return;
    if (button) button.disabled = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var payload = { id: id, quantity: quantity && quantity > 0 ? quantity : 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      payload.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status) {
          window.alert(data.description || data.message || 'Could not add to cart');
          return;
        }
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
        } else if (cart && typeof cart.open === 'function') {
          cart.open();
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ed-customer-wishlist',
            productVariantId: id,
            cartData: data,
          });
        }
      })
      .catch(function () {})
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  customElements.define('ed-customer-wishlist', EdCustomerWishlist);
})();
